import {Folder, FolderType, FolderPreviewContentType} from '../types';
import {useQuery} from 'react-query';
import {useIsFocused, useRoute} from '@react-navigation/native';
import {getFoldersByType} from '../api';
import {FolderParams} from '../types/nav';
import {useFolderMutations} from './useFolderMutations';

export const useFolders = (
  folderType: FolderType,
  disabled: boolean,
  mnemonic?: string,
) => {
  const route = useRoute();
  const params = route.params as FolderParams;
  const routeFolderId = params?.folderId;
  const isFocused = useIsFocused();
  // console.info('mnemonic', mnemonic);
  const mnemoKey = mnemonic || '';
  const foldersQuery = useQuery(
    'folders_' + folderType + mnemoKey,
    async () => {
      const data = await getFoldersByType(folderType, mnemonic);

      const hasNew = data.find(i => i.id === 'new_' + folderType);
      if (!hasNew && folderType !== FolderType.database)
        data.unshift({
          id: 'new_' + folderType,
          title: 'New',
          isFolder: true,
          date: new Date().valueOf(),
          userId: '',
          folderType,
          orderId: 0,
        });
      return data;
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: true,
      enabled: !disabled,
    },
  );
  const loadingFolders = foldersQuery.isFetching;
  const folders = foldersQuery?.data || [
    {
      id: 'new_' + folderType,
      title: 'New',
      isFolder: true,
      date: new Date().valueOf(),
      userId: '',
      folderType,
    },
  ];

  const mutations = useFolderMutations(
    folderType,
    folders as FolderPreviewContentType[],
    foldersQuery,
  );
  return {
    ...mutations,
    folderType,
    currentFolderId: routeFolderId,
    getItem: (_data: unknown, index: number) =>
      folders[index] as Folder,
    getItemCount: () => folders.length,
    loadingFolders,
    folders: folders as Folder[],
    isFocused,
    isLoadingFolder: foldersQuery.isLoading,
  };
};
